import axios from 'axios';

// Base URL for the API
const API_URL = `${process.env.REACT_APP_API_URL}/services`;

// Get the JWT token from local storage or any storage you're using
const token = localStorage.getItem('token');

// Common Axios config with Authorization header
const config = {
  headers: {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }
};

// Fetch all services
export const getServices = async () => {
  try {
    const response = await axios.get(API_URL, config);
    return response;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

// Fetch a single service by ID
export const getServiceById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, config);
    return response;
  } catch (error) {
    console.error('Error fetching service by ID:', error);
    throw error;
  }
};

// Create a new service
export const createService = async (serviceData) => {
  try {
    const response = await axios.post(API_URL, serviceData, config);
    return response;
  } catch (error) {
    console.error('Error creating service:', error);
    throw error;
  }
};

// Update an existing service
export const updateService = async (id, serviceData) => {
  try {
    const response = await axios.put(`${API_URL}/${id}`, serviceData, config);
    return response;
  } catch (error) {
    console.error('Error updating service:', error);
    throw error;
  }
};

// Delete a service
export const deleteService = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`, config);
    return response;
  } catch (error) {
    console.error('Error deleting service:', error);
    throw error;
  }
};
